(function () {
  if (window.__buyPlanCadenceInit) return;
  window.__buyPlanCadenceInit = true;

  function sectionCards(card) {
    const root = card && card.closest('.selling-plans--buy-plans');
    if (!root) return [];
    return root.querySelectorAll('.plan-card');
  }

  function activateCadence(card, planId, qty, discountPercent) {
    if (!card || !planId) return;

    const radio = card.querySelector('.selling_plan_custom');
    if (radio) {
      radio.value = planId;
      radio.setAttribute('data-qty', qty || '1');
      radio.checked = true;
      syncGiftSet(radio);
    }

    card.setAttribute('data-selling-plan-id', planId);
    card.classList.add('active');

    card.querySelectorAll('[data-buy-plan-id]').forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-buy-plan-id') === String(planId));
    });

    const percent = parseInt(discountPercent, 10) || 0;
    const discountRow = card.querySelector('[data-buy-plan-discount]');
    if (discountRow) {
      const valueEl = discountRow.querySelector('[data-buy-plan-discount-value]');
      if (valueEl && percent > 0) valueEl.textContent = String(percent);
      discountRow.classList.toggle('is-active', percent > 0);
    }

    sectionCards(card).forEach(function (other) {
      if (other !== card) other.classList.remove('active');
    });

    syncVariantToPlan(card, planId);
    updateUnitPrice(card);
  }

  function allocationMap(root) {
    if (!root) return null;
    if (Object.prototype.hasOwnProperty.call(root, '_buyPlanAllocations')) {
      return root._buyPlanAllocations;
    }
    const node = root.querySelector('[data-buy-plan-allocations]');
    if (!node) {
      root._buyPlanAllocations = null;
      return null;
    }
    try {
      root._buyPlanAllocations = JSON.parse(node.textContent);
    } catch (err) {
      root._buyPlanAllocations = null;
    }
    return root._buyPlanAllocations;
  }

  function variantsForPlan(map, planId) {
    const id = String(planId);
    const matched = [];
    Object.keys(map).forEach(function (variantId) {
      const plans = map[variantId] || [];
      for (let i = 0; i < plans.length; i++) {
        if (String(plans[i]) === id) {
          matched.push(String(variantId));
          break;
        }
      }
    });
    return matched;
  }

  function variantForPlan(map, planId, current) {
    const allowed = variantsForPlan(map, planId);
    if (!allowed.length) return '';
    if (current && allowed.indexOf(String(current)) !== -1) return String(current);
    return allowed[0];
  }

  function syncGiftSet(node) {
    const plans = node && node.closest && node.closest('.selling-plans--buy-plans');
    if (!plans) return;
    const productId = plans.getAttribute('data-product-id');
    if (!productId) return;
    const radio = plans.querySelector('.selling_plan_custom:checked');
    const giftSet = radio ? (radio.getAttribute('data-gift-set') || '') : '';
    const scope = plans.closest('product-info') || document;
    scope.querySelectorAll('product-form[data-product-id="' + productId + '"] [name="properties[_gift_set]"]').forEach(function (input) {
      input.value = giftSet;
      input.disabled = !giftSet;
    });
  }

  function setFormVariant(productId, variantId) {
    if (!productId || !variantId) return;
    document.querySelectorAll('product-form[data-product-id="' + productId + '"]').forEach(function (form) {
      form.querySelectorAll('[name="id"]').forEach(function (input) {
        if (String(input.value) === String(variantId)) return;
        input.value = variantId;
        input.setAttribute('value', variantId);
      });
    });
  }

  function formatMoney(cents, format) {
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var fraction = parts[1] ? decimal + parts[1] : '';
      return dollars + fraction;
    }
    var template = format || '£{{amount}}';
    var match = template.match(placeholder);
    var value = withDelimiters(cents, 2);
    if (!match) return template;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return template.replace(placeholder, value);
  }

  function updateUnitPrice(card) {
    if (!card) return;
    var unit = card.querySelector('[data-buy-plan-unit]');
    if (!unit) return;
    var size = parseFloat(unit.getAttribute('data-serving-size'));
    if (!size) return;
    var active = card.querySelector('.plan-variant-prices.is-active .variant-price-item.active');
    if (!active) return;
    var price = parseInt(active.getAttribute('data-price'), 10);
    if (isNaN(price)) return;
    var root = card.closest('.selling-plans--buy-plans');
    var format = root && root.getAttribute('data-money-format');
    var valueEl = unit.querySelector('[data-buy-plan-unit-value]');
    if (!valueEl) return;
    valueEl.textContent = formatMoney(Math.round(price / size), format);
  }

  function showPrices(container, variantId) {
    if (!container || !variantId) return;
    container.querySelectorAll('.variant-price-item').forEach(function (item) {
      item.classList.toggle('active', item.getAttribute('data-vid') === String(variantId));
    });
    var card = container.closest && container.closest('.plan-card');
    if (card) updateUnitPrice(card);
  }

  function oneTimeOnlyIds(productId) {
    const node = document.querySelector(
      '[data-one-time-only-variants][data-product-id="' + productId + '"]'
    );
    if (!node) return [];
    if (Object.prototype.hasOwnProperty.call(node, '_oneTimeOnlyIds')) return node._oneTimeOnlyIds;
    try {
      node._oneTimeOnlyIds = JSON.parse(node.textContent).map(String);
    } catch (err) {
      node._oneTimeOnlyIds = [];
    }
    return node._oneTimeOnlyIds;
  }

  function isOneTimeOnlyVariant(productId, variantId) {
    if (!productId || variantId == null || variantId === '') return false;
    return oneTimeOnlyIds(productId).indexOf(String(variantId)) !== -1;
  }

  function applyOneTimeOnly(productId, variantId, scope) {
    if (!scope) return;
    const restricted = isOneTimeOnlyVariant(productId, variantId);
    scope.querySelectorAll('.selling-plans[data-product-id="' + productId + '"]').forEach(function (root) {
      root.classList.toggle('is-one-time-only', restricted);

      const subscriptionRadios = root.querySelectorAll('.plan-card:not(.plan-card--one-time) .selling_plan_custom');

      if (restricted) {
        const checked = Array.prototype.filter.call(subscriptionRadios, function (radio) {
          return radio.checked;
        });
        if (checked.length) {
          subscriptionRadios.forEach(function (radio) {
            delete radio.dataset.wasChecked;
          });
          checked.forEach(function (radio) {
            radio.dataset.wasChecked = 'true';
          });
        } else if (!Array.prototype.some.call(subscriptionRadios, function (radio) {
          return radio.dataset.wasChecked === 'true';
        })) {
          root.querySelectorAll('.plan-card:not(.plan-card--one-time) .selling_plan_custom[data-default-plan="true"]').forEach(function (radio) {
            radio.dataset.wasChecked = 'true';
          });
        }
      }

      subscriptionRadios.forEach(function (radio) {
        const card = radio.closest('.plan-card');
        if (restricted) {
          radio.checked = false;
          radio.disabled = true;
          if (card) {
            card.classList.remove('active');
            card.setAttribute('aria-disabled', 'true');
          }
        } else {
          radio.disabled = false;
          if (card) card.removeAttribute('aria-disabled');
          if (radio.dataset.wasChecked === 'true') {
            radio.checked = true;
            if (card) card.classList.add('active');
          }
          delete radio.dataset.wasChecked;
        }
      });

      root.querySelectorAll('[data-buy-plan-cadence]').forEach(function (select) {
        select.disabled = restricted;
      });

      const oneTime = root.querySelector('.selling_plan_custom[data-one-time="true"]');
      if (oneTime) {
        const oneTimeCard = oneTime.closest('.plan-card');
        if (restricted) {
          oneTime.checked = true;
          if (oneTimeCard) oneTimeCard.classList.add('active');
        } else {
          const subscriptionChecked = root.querySelector(
            '.plan-card:not(.plan-card--one-time) .selling_plan_custom:checked'
          );
          if (subscriptionChecked) {
            oneTime.checked = false;
            if (oneTimeCard) oneTimeCard.classList.remove('active');
          }
        }
      }
      syncGiftSet(root);
    });
  }

  function scopeForProductForm(form) {
    if (!form) return null;
    const info = form.closest('product-info');
    if (info) return info;
    let node = form.parentElement;
    while (node && node !== document.body) {
      if (node.querySelector('.selling-plans') && !node.querySelector('product-info')) return node;
      node = node.parentElement;
    }
    return null;
  }

  function syncOneTimeOnlyFromForms() {
    document.querySelectorAll('product-form[data-product-id]').forEach(function (form) {
      const scope = scopeForProductForm(form);
      if (!scope) return;
      const input = form.querySelector('[name="id"]');
      if (!input) return;
      applyOneTimeOnly(form.getAttribute('data-product-id'), input.value, scope);
    });
  }

  function syncVariantToPlan(card, planId) {
    const root = card && card.closest('.selling-plans--buy-plans');
    const map = allocationMap(root);
    if (!map || !planId) return;

    const radio = card.querySelector('.selling_plan_custom');
    const productId = radio && radio.getAttribute('data-pid');
    if (!productId) return;

    const scope = card.closest('product-info');
    const form = (scope && scope.querySelector('product-form[data-product-id="' + productId + '"]'))
      || document.querySelector('product-form[data-product-id="' + productId + '"]');
    const idInput = form && form.querySelector('[name="id"]');
    const current = idInput ? String(idInput.value) : '';
    if (isOneTimeOnlyVariant(productId, current)) return;
    const next = variantForPlan(map, planId, current);
    if (!next) return;

    setFormVariant(productId, next);
    showPrices(card, next);

    const priceScope = root.closest('product-info') || document;
    priceScope.querySelectorAll('.one-time-subscription-btn').forEach(function (button) {
      if (button.hasAttribute('data-one-time-variant-id')) return;
      showPrices(button, next);
    });
  }

  function syncAllCards(root) {
    const map = allocationMap(root);
    if (!map) return;

    root.querySelectorAll('.plan-card').forEach(function (card) {
      const radio = card.querySelector('.selling_plan_custom');
      if (!radio) return;
      const productId = radio.getAttribute('data-pid');
      const scope = root.closest('product-info');
      const form = (scope && scope.querySelector('product-form[data-product-id="' + productId + '"]'))
        || document.querySelector('product-form[data-product-id="' + productId + '"]');
      const idInput = form && form.querySelector('[name="id"]');
      const current = idInput ? String(idInput.value) : '';
      const next = variantForPlan(map, radio.value, radio.checked ? '' : current);
      if (next) showPrices(card, next);
    });

    const checked = root.querySelector('.selling_plan_custom:checked');
    const checkedCard = checked && checked.closest('.plan-card');
    if (checkedCard) syncVariantToPlan(checkedCard, checked.value);
  }

  document.addEventListener('change', function (event) {
    const select = event.target.closest('[data-buy-plan-cadence]');
    if (!select || select.disabled || select.closest('.selling-plans.is-one-time-only')) return;

    const card = select.closest('.plan-card');
    const option = select.options[select.selectedIndex];
    if (!card || !option) return;

    activateCadence(
      card,
      option.value,
      option.getAttribute('data-qty'),
      option.getAttribute('data-discount-percent')
    );
  });

  document.addEventListener('change', function (event) {
    const radio = event.target.closest('.selling-plans--buy-plans .selling_plan_custom');
    if (!radio || radio.disabled || radio.closest('.selling-plans.is-one-time-only')) return;

    const card = radio.closest('.plan-card');
    if (!card) return;

    sectionCards(card).forEach(function (other) {
      other.classList.toggle('active', other === card);
    });

    syncVariantToPlan(card, radio.value);
    syncGiftSet(radio);
  });

  document.addEventListener('click', function (event) {
    const card = event.target.closest('.selling-plans--buy-plans .plan-card');
    if (!card || card.closest('.selling-plans.is-one-time-only') || event.target.closest('[data-buy-plan-cadence], summary, details')) return;

    const radio = card.querySelector('.selling_plan_custom');
    if (!radio || radio.checked || radio.disabled) return;

    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (event) {
    const input = event.target;
    if (!input || input.name !== 'id') return;
    const form = input.closest('product-form');
    if (!form) return;
    const scope = scopeForProductForm(form);
    if (!scope) return;
    applyOneTimeOnly(form.getAttribute('data-product-id'), input.value, scope);
  });

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!form || !form.closest) return;
      const productForm = form.closest('product-form');
      if (!productForm) return;
      const productId = productForm.getAttribute('data-product-id');
      const idInput = form.querySelector('[name="id"]');
      const scope = scopeForProductForm(productForm);
      const oneTime = scope && scope.querySelector('.selling-plans--buy-plans .selling_plan_custom[data-one-time="true"]:checked');
      if (oneTime && idInput) {
        const pinnedId = oneTime.getAttribute('data-one-time-variant-id');
        if (pinnedId) {
          if (!idInput.dataset.originalVariantId) idInput.dataset.originalVariantId = idInput.value;
          idInput.value = pinnedId;
        }
        form.querySelectorAll('[name="selling_plan"]').forEach(function (input) {
          input.remove();
        });
        form.querySelectorAll('[name="properties[_gift_set]"]').forEach(function (input) {
          input.value = '';
          input.disabled = true;
        });
      }
      const variantId = idInput ? idInput.value : '';
      if (!isOneTimeOnlyVariant(productId, variantId)) return;
      if (scope) applyOneTimeOnly(productId, variantId, scope);
      form.querySelectorAll('[name="selling_plan"]').forEach(function (input) {
        input.remove();
      });
      form.querySelectorAll('[name="properties[_gift_set]"]').forEach(function (input) {
        input.value = '';
        input.disabled = true;
      });
    },
    true
  );

  function bootOneTimeOnly() {
    document.querySelectorAll('.selling-plans--buy-plans').forEach(syncAllCards);
    document.querySelectorAll('.selling-plans--buy-plans').forEach(syncGiftSet);
    syncOneTimeOnlyFromForms();
  }

  bootOneTimeOnly();
  window.addEventListener('load', bootOneTimeOnly);
  setTimeout(bootOneTimeOnly, 0);
  setTimeout(bootOneTimeOnly, 1200);
})();
